// removed by extract-text-webpack-plugin
module.exports = {"logo":"logo_x_x","spacer":"logo_x_spacer"};


//////////////////
// WEBPACK FOOTER
// ../node_modules/@cube/logo-widget/src/components/logo/style.less
// module id = 440
// module chunks = 9 10 12